<ul *ngIf="hasExams()" id="examBody" class="list-group">
  <form #examRequestForm="ngForm">
    <div class="form-group">
      <label for="rootCause">Indicação clínica:</label>
      <input class="form-control" type="text" name="rootCause" required maxlength="150" [(ngModel)]="examRequest.root_cause" />
    </div>
    <span *ngFor="let exam of examRequest.exam_templates">
      <li class="list-group-item">{{exam.name}}</li>
    </span>
  </form>
</ul>
<div *ngIf="!hasExams()" class="form-control">Nenhum procedimento adicionado</div>

<div class="mt-2">
  <button (click)="searchExamTemplate()" class="btn btn-outline-primary float-left">Adicionar procedimento</button>
  <button [disabled]="!hasExams()" (click)="save()" [hidden]="detached" class="btn btn-primary float-right ml-1">Salvar</button>
  <!-- <button (click)="print()" [hidden]="!detached" class="btn btn-primary float-right ml-1">Imprimir</button> -->
  <button (click)="cancel()" class="btn btn-secondary float-right">{{ detached ? 'Fechar' : 'Cancelar' }}</button>
</div>

<!-- Modal -->
<div class="modal fade" #createNewModal tabindex="-1" role="dialog" aria-labelledby="createNewModal" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Pesquisar procedimento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <mc-exam-template-index [crudMode]="false" (selected)="selectedTemplate($event)"></mc-exam-template-index>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>
